/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { core_Institution } from './core_Institution';
export type b2b_v1_users_Account = {
    asset_type?: b2b_v1_users_Account.asset_type;
    balance?: number;
    currency: string;
    id?: string;
    institution?: core_Institution;
    investment_type?: b2b_v1_users_Account.investment_type;
    is_manual_account?: boolean;
    loan_type?: b2b_v1_users_Account.loan_type;
    market_value?: number;
    name: string;
    number?: string;
    type: b2b_v1_users_Account.type;
};
export namespace b2b_v1_users_Account {
    export enum asset_type {
        HOME = 'home',
    }
    export enum investment_type {
        AF = 'af',
        ISK = 'isk',
        KF = 'kf',
        TJP = 'tjp',
        DEPOT = 'depot',
        OTHER = 'other',
    }
    export enum loan_type {
        MORTGAGE = 'mortgage',
        BLANCO = 'blanco',
        MEMBERSHIP = 'membership',
        VEHICLE = 'vehicle',
        LAND = 'land',
        STUDENT = 'student',
        CREDIT = 'credit',
        OTHER = 'other',
    }
    export enum type {
        CHECKING = 'checking',
        SAVINGS = 'savings',
        INVESTMENT = 'investment',
        CREDIT_CARD = 'credit_card',
        LOAN = 'loan',
        PENSION = 'pension',
        ASSET = 'asset',
        BANK_ACCOUNT = 'bank_account',
        OTHER = 'other',
    }
}

